export const ALERT_TYPE = {
  WARNING: "warning",
  ERROR: "danger",
  SUCCESS: "success",
  INFO: "info",
};
